import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Container from '@material-ui/core/Container';
import Link from '@material-ui/core/Link';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import DateFnsUtils from '@date-io/date-fns';
import {
    MuiPickersUtilsProvider,
    KeyboardTimePicker,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import { useLocation, useHistory } from "react-router-dom";
import onSubmitBiodata from './SubmitBiodata'
import Header from '../Element/Header'


const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(4),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    input: {
        marginTop: '3%'
    },
    root: {
        marginTop: '2%'
    },
    large: {
        width: theme.spacing(10),
        height: theme.spacing(10),
    },
    header: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    typography: {
        marginTop: '5%'
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));

export default function EducationRegister() {
    const classes = useStyles();
    const history = useHistory();
    const location = useLocation();
    const [competency, setCompetency] = useState('')
    const [institution, setInstitution] = useState('')
    const [lastEducation, setLastEducation] = useState('')
    const [majors, setMajors] = useState('')
    const [graduationYear, setGraduationYear] = useState('')
    const [gpa, setGpa] = useState('')
    const [upload, setUpload] = useState('')
    const [biodata, setBiodata] = useState({})

    useEffect(async () => {
        let getStorageBiodata = JSON.parse(localStorage.getItem("biodata"))

        if (getStorageBiodata !== null) {
            setBiodata(getStorageBiodata)
        }

        if (location.state.exist === true) {
            setCompetency(location.state.getParticipant.participant_biodatum.competency)
            setInstitution(location.state.getParticipant.participant_biodatum.edu_institution)
            setLastEducation(location.state.getParticipant.participant_biodatum.edu_degree)
            setMajors(location.state.getParticipant.participant_biodatum.edu_major)
            setGraduationYear(location.state.getParticipant.participant_biodatum.edu_grad_year)
            setGpa(location.state.getParticipant.participant_biodatum.edu_grade)
            setUpload(location.state.getParticipant.participant_biodatum.photo)
        }
        // console.log(getStorageBiodata)
    }, [location])

    const handleChangeUpload = (event) => {
        setUpload(event.target.files[0])
    }

    return (
        <Container component="main" maxWidth="sm">
            <CssBaseline />
            <div className={classes.header}>
                {/* <Avatar alt="Jababeka Logo" src="/participant/logo512.png" variant="square" className={classes.large} />
                <Typography component="h1" variant="h5">
                    KAWASAN INDUSTRI JABABEKA
                </Typography>
                <Typography variant="subtitle1">
                    PROUDLY PRESENT
                </Typography>
                <Typography component="h1" variant="h6" gutterBottom>
                    VIRTUAL JOB FAIR 2021
                </Typography> */}
                <Header />
                <Typography component="h1" variant="h6" gutterBottom>
                    {location.state.countParticipant ? `Peserta ${location.state.countParticipant}` : null}
                </Typography>
            </div>
            <div className={classes.paper}>
                <Container component="main" maxWidth="md" className={classes.root}>
                    <TextField
                        id="outlined-multiline-static"
                        label="Prestasi & Kompetensi"
                        fullWidth
                        multiline
                        rows={5}
                        variant="outlined"
                        onChange={e => setCompetency(e.target.value)}
                        value={competency}
                        size="small"
                    />
                    <Typography component="h5" bold="true" className={classes.typography}>
                        PENDIDIKAN
                    </Typography>

                    <TextField
                        variant="outlined"
                        required
                        fullWidth
                        id="institution"
                        label="Institusi"
                        name="institution"
                        autoComplete="institution"
                        className={classes.input}
                        onChange={e => setInstitution(e.target.value)}
                        value={institution}
                        size="small"
                    />

                    <TextField
                        variant="outlined"
                        required
                        fullWidth
                        id="last_education"
                        label="Pendidikan Terakhir"
                        name="last_education"
                        autoComplete="last_education"
                        className={classes.input}
                        onChange={e => setLastEducation(e.target.value)}
                        value={lastEducation}
                        size="small"
                        helperText="Contoh: S1"
                    />

                    <TextField
                        variant="outlined"
                        required
                        fullWidth
                        id="majors"
                        label="Jurusan"
                        name="majors"
                        autoComplete="majors"
                        className={classes.input}
                        onChange={e => setMajors(e.target.value)}
                        value={majors}
                        size="small"
                    />

                    <TextField
                        variant="outlined"
                        required
                        fullWidth
                        id="graduation_year"
                        label="Tahun Lulus"
                        name="graduation_year"
                        autoComplete="graduation_year"
                        className={classes.input}
                        onChange={e => setGraduationYear(e.target.value)}
                        value={graduationYear}
                        size="small"
                    />

                    <TextField
                        variant="outlined"
                        required
                        fullWidth
                        id="GPA"
                        label="IPK"
                        name="GPA"
                        autoComplete="GPA"
                        className={classes.input}
                        onChange={e => setGpa(e.target.value)}
                        value={gpa}
                        size="small"
                        helperText="Contoh: 3.45 (desimal menggunakan titik)"
                    />

                    <Button
                        variant="outlined"
                        component="label"
                        fullWidth
                        className={classes.input}
                    >
                        Pas Foto
                        <input
                            type="file"
                            hidden
                            onChange={handleChangeUpload}
                            accept="image/*"
                            helperText="hanya menerima file dengan format .jpg, .png"
                        />
                    </Button>
                    <Typography variant="caption">
                        <i>Note: hanya menerima file dengan format .jpg, .png</i>
                    </Typography>
                    <Button
                        type="button"
                        fullWidth
                        variant="contained"
                        color="primary"
                        size="large"
                        className={classes.submit}
                        onClick={() => onSubmitBiodata(competency, institution, lastEducation, majors, graduationYear, gpa, biodata, history, upload, location)}
                    >
                        LANJUTKAN
                    </Button>
                </Container>
            </div>
        </Container>
    )
}
